const recursivelyToCamel = (item: unknown): unknown => {
  if (Array.isArray(item)) {
    return item.map((el: unknown) => recursivelyToCamel(el));
  } else if (typeof item === "function" || item !== Object(item)) {
    return item;
  }
  return Object.fromEntries(
    Object.entries(item as Record<string, unknown>).map(
      ([key, value]: [string, unknown]) => [
        key.replace(/([-_][a-z,0-9])/gi, (c) =>
          c.toUpperCase().replace(/[-_]/g, "")
        ),
        recursivelyToCamel(value),
      ]
    )
  );
};

export default recursivelyToCamel;
